export const redirect = (url, target) => {
  const to = url.includes('http') ? url : `https://${url}`;
  return window.open(to, target);
};
